import { useMutation } from '@tanstack/react-query';
import {
  type HandleBatchTaskOptions,
  handleBatchTask,
} from 'shared/api/batches';
import { postDocuments } from '../requests';
import type { PostDocumentRequestType } from '../types';

export const usePostDocument = (options?: HandleBatchTaskOptions) =>
  useMutation({
    mutationFn: (params: PostDocumentRequestType) =>
      handleBatchTask(postDocuments(params), options),
  });
